import { useQuery } from "@tanstack/react-query";
import { fetchMotivationalQuote } from "../../../api/fetchMotivationalQuote";

export const useMotivationalQuoteQuery = () =>
  useQuery({
    queryKey: ["quote"],
    queryFn: () => fetchMotivationalQuote(),
  });
